let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("deZDr")).then(() => parcelRequire('mkvWp'));